import React, { useRef } from 'react'
import { useField } from 'formik'
import { CFieldProps } from '@velocity/shared'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCameraRetro, faX } from '@fortawesome/free-solid-svg-icons'
import { fileSrc } from '../FileLoader'
import { defaultLogo } from '../../consts'

export const ImageSelectInput = (props: CFieldProps) => {
  const [, meta] = useField(props.name)
  return (
    <div className='relative inline-block'>
      <div className='w-fit border border-slate-500'>
        <img
          className='inline-block h-[8rem] m-1'
          src={
            meta.value instanceof File ? URL.createObjectURL(meta.value)
            : meta.value ?
              fileSrc({
                id: meta.value,
                provider: 'cloudinary'
              })
            : defaultLogo
          }
          alt='Business Logo'
        />
      </div>
      <LogoSelectInput {...props} />
    </div>
  )
}

const LogoSelectInput = (props: CFieldProps) => {
  const [, meta, helpers] = useField(props.name)
  const fileInputRef: any = useRef(null)

  const handleButtonClick = () => {
    fileInputRef.current.click()
  }

  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files[0]
    helpers.setValue(selectedFile)
  }

  return (
    <div>
      <input
        type='file'
        id='file'
        name='file'
        onChange={handleFileChange}
        className='hidden'
        ref={fileInputRef}
        {...props.fileProps}
      />
      {meta.value && (
        <button
          type='button'
          onClick={() => helpers.setValue('')}
          className={`absolute top-1 right-1 block text-white h-6 w-6 rounded-full ring-2 ring-white bg-red-500`}
        >
          <FontAwesomeIcon icon={faX} size='xs' />
        </button>
      )}
      <button
        type='button'
        onClick={handleButtonClick}
        className={`absolute bottom-1 end-1 block text-white h-6 w-6 rounded-full ring-2 ring-white bg-primary`}
      >
        <FontAwesomeIcon icon={faCameraRetro} />
      </button>
    </div>
  )
}
